import axios from "axios";
import { BASEURL } from "../../../config";
import authAxios from "../../../Config/AuthAxios";


export const LoginApi = async (data) => {
  try {
    const loginData = {
      email: data.email,
      password: data.password,
    };

    const res = await authAxios.post("login", loginData);

    return res;
  } catch (err) {
    return err;
  }
};

// export const LoginApi = async (data) => {
//   try {
//     const loginData = {
//       email: data.email,
//       password: data.password,
//     };

//     const res = await axios({
//       method: "POST",
//       url: BASEURL + "login",
//       data: loginData,
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//     });

//     return res;
//   } catch (err) {
//     return err;
//   }
// };

export const LoginVarificationApi = async (data) => {
  try {
    const varifyData = {
      password: data.code,
    };

    const res = await axios({
      method: "POST",
      url: BASEURL + "login",
      data: varifyData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return res;
  } catch (err) {
    return err;
  }
};

export const RegistrationApi = async (data) => {
  try {
    let {
      company_name,
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
    } = data;
    const RegisterData = {
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
      company_name,
    };

    const res = await axios({
      method: "POST",
      url: BASEURL + "register",
      data: RegisterData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return res;
  } catch (err) {
    return err;
  }
};

export const VerificationApi = async (data) => {
  try {
    const VerificationData = {
      email: data.email,
      code: data.code,
    };

    const res = await axios({
      method: "POST",
      url: BASEURL + "confirm-registration",
      data: VerificationData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return res;
  } catch (err) {
    return err;
  }
};

export const MRFverifyCodeApi = async (data) => {
  try {
    const VerificationData = JSON.stringify(data, null, 2);
    const res = await axios({
      method: "POST",
      url: BASEURL + "auth/respond-to-challenge",
      data: VerificationData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return res;
  } catch (err) {
    return err;
  }
};

export const ForgetPasswordApi = async (data) => {
  try {
    const forgetData = {
      username: data.email,
    };
    const res = await axios({
      method: "POST",
      url: BASEURL + "users/forgot-password",
      data: forgetData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return res;
  } catch (err) {
    return err;
  }
};

export const ForgetVerificationApi = async (data) => {
  try {
    const forgetverificationData = {
      username: data.username,
      code: data.code,
      password: data.password,
    };
    const res = await axios({
      method: "POST",
      url: BASEURL + "users/confirm-reset-password",
      data: forgetverificationData,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return res;
  } catch (err) {
    return err;
  }
};